import { Marquee } from "../ds/core";
import { industryGallery } from "./IndustriesGallery";
import { useLocale } from "../i18n/useLocale";

/**
 * IndustriesMarquee — a running strip of industry cards. Each card is a white
 * tile with the industry photo inset 8px from the edges (p-2), linked to the
 * next card by a white "bridge" across the gap (centred on the seam). Reuses the
 * DS Marquee (seamless loop, edge fade, pause-on-hover, reduced-motion aware).
 */
export function IndustriesMarquee({
  className = "bg-bg py-8",
  durationSec,
  reverse = false,
}: {
  className?: string;
  durationSec?: number;
  reverse?: boolean;
} = {}) {
  const { t } = useLocale();
  return (
    <Marquee className={className} durationSec={durationSec} reverse={reverse}>
      {industryGallery(t).map((item) => (
        <div
          key={item.title}
          className="relative mr-[22px] h-[200px] w-[300px] shrink-0 rounded-3xl bg-ds-hero p-2 shadow-[0_12px_30px_-12px_rgba(15,23,42,0.22)]"
        >
          <img
            src={item.image.url}
            alt={item.title}
            loading="lazy" decoding="async"
            className="h-full w-full rounded-2xl object-cover"
            style={{ objectPosition: item.image.pos || "center" }}
          />
          {/* bridge to the next card — Figma "ContainerConnector" vector: a white
              dumbbell that's full-height at each card edge and pinches to a waist
              across the 30px gap (mr-[22px] + the marquee's gap-2). Shifted 1px
              into the card so both ends tuck 1px under the tiles — a negative gap
              that hides the hairline seam between card and connector. */}
          <svg
            aria-hidden
            viewBox="0 0 32 50"
            width="32"
            height="50"
            fill="none"
            className="absolute left-[calc(100%-1px)] top-1/2 z-10 -translate-y-1/2"
          >
            <path
              d="M0 0H1V50H0V0ZM31 15H1V0C1 0 1 15 16 15C31 15 31 0 31 0V15ZM1 15H31V35H1V15ZM1 35H31V50C31 50 31 35 16 35C1 35 1 50 1 50V35ZM31 0H32V50H31V0Z"
              fill="var(--ds-hero)"
            />
          </svg>
        </div>
      ))}
    </Marquee>
  );
}
